import { type TimeDuration } from "@and3k5/timespan.js";
import { type TimeParts } from "./types";

export function getDateParts(
    duration: TimeDuration,
    timeLabels: {
        days: string;
        hours: string;
        minutes: string;
        seconds: string;
    }
): TimeParts {
    const time = duration.getAllTime();
    return {
        days: {
            unit: timeLabels.days,
            value: time.days,
        },
        hours: {
            unit: timeLabels.hours,
            value: time.hours,
        },
        minutes: {
            unit: timeLabels.minutes,
            value: time.minutes,
        },
        seconds: {
            unit: timeLabels.seconds,
            value: time.seconds,
        },
    };
}

export function isValidSecondsleft(secondsLeft: number) {
    return secondsLeft < 3153600000;
}
